export enum PrivilegesModules {
    EventsControl = 'bo.events.control',
    EventsPt = 'bo.events.pt',
    AcmanUsers = 'bo.acman.users',
    AcmanOrgRoles = 'bo.acman.orgroles',
    RefsRoutes = 'bo.refs.routes',
    RefsPlaces = 'bo.refs.places',
    RefsValidators = 'bo.refs.validators',
    RefsTariffs = 'bo.refs.tariffs',
    RefsProviders = 'bo.refs.providers',
    RefsPrivcat = 'bo.refs.privcat',
    DiscCoupons = 'bo.disc.coupons',
    ValmanMonitoring = 'bo.valman.monitoring',
    Load = 'bo.load',
    AgentsAgents = 'bo.agents.agents',
    AgentsOrders = 'bo.agents.orders',
    B2bLoad = 'bo.b2b.load',
    B2bRidersSearch = 'bo.b2b.search',
    B2bRiderAdd = 'bo.b2b.rider',
    B2bPrtnr = 'bo.b2b.prtnr',
    SysadmParams = 'bo.sysadm.params',
    SysadmAppearance = 'bo.sysadm.appearance',
    AntifraudControl = 'bo.antifraud.control',
    AnmanDashboard = 'bo.anman.dashboard',
    AnmanReports = 'bo.anman.reports',
    ReportsLoad = 'bo.reports.load',
    SupportSpoil = 'bo.support.spoil',
    SupportClients = 'bo.support.clients',
    SupportRefunds = 'bo.support.refunds',
}
